var map = {
	"./CurationWriteDefaultLayout": [
		"4fc1",
		"chunk-2d0ccf56"
	],
	"./CurationWriteDefaultLayout.vue": [
		"4fc1",
		"chunk-2d0ccf56"
	],
	"./CurationWriteItemsLayout": [
		"7a35",
		"chunk-2d0e13e2"
	],
	"./CurationWriteItemsLayout.vue": [
		"7a35",
		"chunk-2d0e13e2"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "014c";
module.exports = webpackAsyncContext;